"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@linaria/core");
var _commonStyles = require("../styles/commonStyles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const recommendationsSkeletonStyles = "r6bfl9n";
const RecoreMarqueeSkeleton = () => {
  const cards = [...new Array(3)].map((_, idx) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'skeletonCard',
      key: `skeleton-card-${idx}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardImage', 'd-block')
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "cardText"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText1')
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText2')
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText3')
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText4')
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCardText5')
    })));
  });
  const pills = [...new Array(4)].map((_, idx) => {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)('skeletonPill', 'd-block'),
      key: `skeleton-pill-${idx}`
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(recommendationsSkeletonStyles)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonHeading')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'skeletonPillContainer'
  }, pills), /*#__PURE__*/_react.default.createElement("div", {
    className: 'skeletonCardContainer'
  }, cards));
};
var _default = RecoreMarqueeSkeleton;
exports.default = _default;